<template>
    <div>
        <tit data-aos="fade-up" class="tit--lg white--text">
            따스한 봄을 맞이하도록 도와드리겠습니다. <br />
            <span class="primary--text">봄은 다시 옵니다.</span>
        </tit>
        <span data-aos="fade-up" data-aos-delay="100" class="line my-12px my-md-24px"></span>
        <txt data-aos="fade-up" data-aos-delay="200" class="white--text line-height-17">
            <p class="mb-12px mb-md-24px">이혼전문변호사 최유나입니다. 홈페이지를 찾아주셔서 감사합니다.</p>
            <p>숱한 고민을 거쳐 어렵게 내리신 결정인 만큼, 의뢰인과의 충분한 공감과 소통을 통하여 최고의 법률서비스를 제공해 드리겠습니다. 소송 전 과정에서 의뢰인분의 한마디 한마디에 귀 기울이고, 경청하여 최상의 결과를 안겨드리고 새로운 삶으로 나아갈 수 있는 방향을 설정해 드리겠습니다.</p>
        </txt>
    </div>
</template>

<script>
import tit from "@/components/publish/styles/typography/tit.vue";
import Txt from "@/components/publish/styles/typography/txt.vue";

export default {
    components: { tit, Txt },
};
</script>